import { render } from "./ActivityCenterHeader.vue?vue&type=template&id=63278865&scoped=true"
import script from "./ActivityCenterHeader.vue?vue&type=script&lang=js"
export * from "./ActivityCenterHeader.vue?vue&type=script&lang=js"

import "./ActivityCenterHeader.vue?vue&type=style&index=0&id=63278865&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63278865"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
